import {
  Box,
  Typography,
  Button,
  Container,
  Grid,
  Card,
  CardContent,
} from '@mui/material';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

import banner from '../assets/banner.png';

import herbsImg from '../assets/categories/herbs-spices.png';
import oilsImg from '../assets/categories/oils.jpg';
import categoriesData from '../assets/menus/products.json';
import { appConfig } from '../configs/app-config';

const categories = [
  { title: 'Herbs & Spices', path: '/products/herbs-spices', image: herbsImg, },
  { title: 'Oils', path: '/products/oils', image: oilsImg },
  { title: 'Herbs & Spices New', path: '/products/herbs-spices', image: herbsImg, },
  // { title: 'Oils', path: '/products/oils', image: oilsImg },
  // { title: 'Herbs & Spices', path: '/products/herbs-spices', image: herbsImg, },
  // { title: 'Oils', path: '/products/oils', image: oilsImg },
];
const features = [
  {
    title: 'Pure & Natural',
    desc: 'No artificial colors or preservatives.',
  },
  {
    title: 'Trusted Sourcing',
    desc: 'Directly sourced from reliable farmers.',
  },
  {
    title: 'Hygienic Packing',
    desc: 'Maintained with strict quality standards.',
  },
  {
    title: 'Bulk Supply',
    desc: 'Retail & wholesale orders accepted.',
  },
];
const featuredProducts = [
  'Turmeric Powder',
  'Cumin Seeds',
  'Coriander Powder',
  'Mustard Oil',
];


export default function Home() {
  return (
    <Box>
      {/* ================= HERO BANNER ================= */}
      <Box
        sx={{
          height: { xs: 300, md: 420 },
          backgroundImage: `linear-gradient(
            rgba(0,0,0,0.45),
            rgba(0,0,0,0.45)
          ), url(${banner})`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Container>
          <Typography variant="h3" color="#fff" fontWeight={700}>
            Pure Herbs & Authentic Spices
          </Typography>

          <Typography
            variant="h6"
            color="#f5e6d3"
            sx={{ mt: 1, maxWidth: 500 }}
          >
            Delivering freshness, quality, and tradition to your kitchen
          </Typography>

          <Button
            variant="contained"
            color="secondary"
            sx={{ mt: 3 }}
            component={Link}
            to="/products/super-foods"
          >
            Explore Products
          </Button>
        </Container>
      </Box>

      {/* ================= CATEGORIES ================= */}
      <Container sx={{ py: 6 }}>
        <Typography variant="h4" fontWeight={600} mb={3}>
          Our Categories
        </Typography>

        <Swiper
          spaceBetween={20}
          slidesPerView={1.2}
          breakpoints={{
            600: { slidesPerView: 2 },
            960: { slidesPerView: 3 },
          }}
        >
          {categoriesData.map((cat) => (
            <SwiperSlide key={cat.title}>
              <Box
                component={Link}
                to={`/products/${cat.routeTo}`}
                sx={{
                  height: 200,
                  borderRadius: 3,
                  overflow: 'hidden',
                  position: 'relative',
                  textDecoration: 'none',
                  textAlign: 'center',
                  display: 'block',
                  backgroundImage: `url(/assets/media/categories/${cat.imgPath})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  transition: '0.4s',
                  '&:hover': {
                    transform: 'scale(1.03)',
                  },
                }}
              >
                {/* Overlay */}
                <Box
                  sx={{
                    position: 'absolute',
                    inset: 0,
                    background:
                      'linear-gradient(to top, rgba(0,0,0,0.6), rgba(0,0,0,0.2))',
                  }}
                />

                {/* Text */}
                <Box
                  sx={{
                    position: 'absolute',
                    inset: 0,
                    display: 'flex',
                    alignItems: 'flex-end',
                    p: 2,
                  }}
                >
                  <Typography
                    variant="h6"
                    textAlign='center'
                    sx={{
                      color: '#fff',
                      fontWeight: 600,
                    }}
                  >
                    {cat.name}
                  </Typography>
                </Box>
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>

      {/* ================= WHY CHOOSE US ================= */}
      <Container sx={{ py: 7 }}>
        <Typography variant="h4" fontWeight={600} mb={4}>
          Why Choose Us
        </Typography>

        <Grid container spacing={4}>
          {features.map((f) => (
            <Grid item xs={12} sm={6} md={3} key={f.title}>
              <Card sx={{ height: '100%' }}>
                <CardContent>
                  <Typography variant="h6">
                    {f.title}
                  </Typography>
                  <Typography color="text.secondary" mt={1}>
                    {f.desc}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* ================= FEATURED PRODUCTS ================= */}
      <Box sx={{ py: 7 }}>
        <Container>
          <Typography variant="h4" fontWeight={600} mb={4}>
            Popular Products
          </Typography>

          <Grid container spacing={3}>
            {featuredProducts.map((name) => (
              <Grid item xs={12} sm={6} md={3} key={name}>
                <Card>
                  <CardContent>
                    <Typography variant="h6">
                      {name}
                    </Typography>
                    <Button
                      fullWidth
                      variant="contained"
                      sx={{ mt: 2 }}
                      href={`tel:${appConfig.appAuthorPhone}`}
                    >
                      Call Now
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* ================= QUALITY PROMISE ================= */}
      <Container sx={{ py: 7 }}>
        <Typography variant="h4" fontWeight={600} mb={2}>
          Our Quality Promise
        </Typography>
        <Typography maxWidth={720} color="text.secondary">
          Every product goes through strict quality checks to ensure purity,
          freshness, and authentic taste. From sourcing to packaging, we
          maintain hygienic and traditional standards you can trust.
        </Typography>
      </Container>

      {/* ================= TESTIMONIAL ================= */}
      <Box
        sx={{
          backgroundColor: 'primary.main',
          color: '#fff',
          py: 6,
        }}
      >
        <Container>
          <Typography variant="h4" fontWeight={600} mb={3}>
            What Our Customers Say
          </Typography>

          <Typography maxWidth={620}>
            “Excellent quality spices with rich aroma. Very reliable supplier
            for bulk and wholesale orders.”
          </Typography>

          <Typography mt={2} fontWeight={600}>
            — Retail Partner, Neemuch
          </Typography>
          <Button
            variant="contained"
            color="secondary"
            sx={{ mt: 2 }}
            component={Link}
            to="/contact"
          >
            Find us
          </Button>
        </Container>
      </Box>

      {/* ================= FINAL CTA ================= */}
      <Box sx={{ py: 7, textAlign: 'center' }}>
        <Typography variant="h5" fontWeight={600}>
          Ready to Place an Order?
        </Typography>
        <Button
          variant="contained"
          color="primary"
          sx={{ mt: 2 }}
          href={`tel:${appConfig.appAuthorPhone}`}
        >
          Call Us Now
        </Button>
      </Box>
    </Box>
  );
}
